export const APP_VERSION = process.env.REACT_APP_VERSION || "0.0.0";
export const BUILD_DATE =
  process.env.REACT_APP_BUILD_DATE || new Date().toISOString().slice(0, 10);
